import React, { useContext, useEffect, useState } from 'react';
import { SalesforceConnection } from '@modules/salesforce/models';
import SalesforceConnectionSwitcher from '@modules/project/settings/components/shared/salesforce-connection-switcher';
import { UserPreferenceContext } from '@contexts/user-preference-context';
import { TruncatedText, useTranslation } from '@testsigma/atoms';
interface SelectMetadaConnectionFormProps {
  selectedConnection;
  setSelectedConnection: (connection: SalesforceConnection) => void;
}

const SelectMetadaConnectionForm: React.FC<SelectMetadaConnectionFormProps> = ({
  selectedConnection,
  setSelectedConnection,
}) => {
  const { t } = useTranslation();

  const userPreferenceContext = useContext(UserPreferenceContext);
  const projectPreference =
    userPreferenceContext?.userPreference?.preference?.projectPreference;
  const defaultApplication = projectPreference?.selectedApplication;
  const defaultProject = projectPreference.selectedProject;

  return (
    <main>
      <div className='px-8 py-2 w-full flex flex-col h-full justify-start gap-4'>
        <div className='flex'>
          <div className='flex flex-col flex-1 gap-1'>
            <span className='text-2xs font-normal text-secondary-500'>
              {t('common.project')}
            </span>
            <TruncatedText
              className='!text-md !font-medium'
              value={defaultProject?.name}
            />
          </div>
          <div className='flex flex-col flex-1 gap-1'>
            <span className='text-2xs font-normal text-secondary-500'>
              {t('common.application')}
            </span>
            <TruncatedText
              className='!text-md !font-medium'
              value={defaultApplication?.name}
            />
          </div>
        </div>
        <div className='flex flex-col py-2 gap-1'>
          <span className='text-2xs font-normal text-secondary-500'>
            {t('metadata.connection.label')}
          </span>

          {/* Salesforce Connection Switcher */}
          <SalesforceConnectionSwitcher
            setSelectedConnection={setSelectedConnection}
          />
        </div>

        {/* Salesforce Environment and Login Info */}
        <div className='flex justify-between'>
          <div className='flex flex-col gap-1'>
            <span className='text-2xs font-normal text-secondary-500'>
              {t('common.salesforce.environment')}
            </span>
            <TruncatedText
              className='!text-md !font-medium'
              value={selectedConnection?.environmentName}
            />
          </div>
        </div>

        {/* Username and Login Method */}
        <div className='flex  py-4'>
          <div className='flex flex-col gap-1 flex-1'>
            <span className='text-2xs font-normal text-secondary-500 '>
              {t('username.label')}
            </span>
            <TruncatedText
              className='!text-md !font-medium !max-w-[220px]'
              value={selectedConnection?.username}
            />
          </div>
          <div className='flex flex-col gap-1 flex-1'>
            <span className='text-2xs font-normal text-secondary-500'>
              {t('login-method.label')}
            </span>
            {selectedConnection ? (
              <span className='text-md font-medium'>
                {selectedConnection.loginMethod === 'OAUTH'
                  ? t('salesforce.login.method.OAUTH')
                  : t('salesforce.login.method.USERNAME_PASSWORD')}
              </span>
            ) : null}
          </div>
        </div>

        <div className='flex flex-col gap-1 bg-secondary-50 p-4 rounded-lg mt-4'>
          <span className='text-[14px] font-medium'>
            {t('metadata.connection.note')}
          </span>
          <span className='text-sm text-secondary-600 '>
            {t('metadata.connection.note.description')}
          </span>
        </div>
      </div>
    </main>
  );
};

export { SelectMetadaConnectionForm };
